import React from 'react';
import { Link } from 'react-router-dom';
import './SearchResults.scss';

const SearchResults = ({ result, loading }) => {
  return (
    <div className={`search-results ${loading ? 'fade-in-black' : ''}`}>
      {result.map(el => (
        <Link key={el.id} to={`/${el.type}/${el.id}`}>
          <div className="search-results-container">
            <img
              className="search-results-container__image"
              src={el.imgSrc}
              alt={el.title}
            />
            <h3 className="search-results-container__title">{el.title}</h3>
            <p className="search-results-container__rating">
              Rating: {el.rating}
            </p>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default SearchResults;
